import { getStatusMessageId } from "./getErrorMessageId";
/**
 * The text an API client screen shows for a failed call (create, enable/disable, delete,
 * new secret).
 *
 * CZNA-1626: a 401, 403, 5xx or a call without a response gets the same sentence as on the
 * user and organization screens ({@link getStatusMessageId}) — the backend's message for
 * those is either absent or a technical one that does not say what to do. Any other failure
 * keeps the backend's own message (it explains a refused request), else the generic one.
 */
export var getApiClientErrorMessage = function (info, intl) {
    var statusMessageId = getStatusMessageId(info);
    if (statusMessageId)
        return intl.formatMessage({ id: statusMessageId });
    return info.message || intl.formatMessage({ id: "ui-czna-users.error.generic" });
};
